import { ContactStatus, SuppressedStatus } from '@dev/ee-api/ee-api-models';

export const contactStatuses = [
    { translationKey: 'active', enumValue: ContactStatus.Active },
    { translationKey: 'transactional', enumValue: ContactStatus.Transactional },
    { translationKey: 'engaged', enumValue: ContactStatus.Engaged },
    { translationKey: 'notconfirmed', enumValue: ContactStatus.NotConfirmed },
    { translationKey: 'bounced', enumValue: ContactStatus.Bounced },
    { translationKey: 'unsubscribed', enumValue: ContactStatus.Unsubscribed },
    { translationKey: 'complained', enumValue: ContactStatus.Abuse },
    { translationKey: 'inactive', enumValue: ContactStatus.Inactive },
    { translationKey: 'stale', enumValue: ContactStatus.Stale },
];

export const suppressionStatuses = [
    { translationKey: 'bounced', enumValue: SuppressedStatus.Bounced },
    { translationKey: 'unsubscribed', enumValue: SuppressedStatus.Unsubscribed },
    { translationKey: 'complained', enumValue: ContactStatus.Abuse },
];
